// DashboardLayout.jsx
import { useState, useRef } from 'react';
import '../css/layout.css';
import DashboardHeader from './DashboardHeader';
import Sidebar from './Sidebar';

const DashboardLayout = ({ children, user }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="dashboard-layout d-flex">
      {/* Sidebar */}
      <nav
        id="sidebarMenu"
        ref={sidebarRef}
        className={`sidebar-custom ${sidebarOpen ? 'show-mobile' : 'd-none d-md-block'}`}
      >
        <Sidebar
          sidebarRef={sidebarRef}
          isOpen={sidebarOpen}
          onCloseSidebar={closeSidebar}
        />

      </nav>

      {/* Overlay oscuro (solo móvil) */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay d-md-none"
          onClick={closeSidebar}
        />
      )}

      {/* Main content */}
      <div className="main-content flex-grow-1">
        <DashboardHeader user={user} onToggleSidebar={toggleSidebar} />
        <main className="p-3 mt-3">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
